
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/brands",
      function () {
        return require("private-next-pages/brands.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/brands"])
      });
    }
  